import ProjectContractForm, {
  ProjectContractForm_TabsContents,
  ProjectContractForm_TabsList,
} from '../project_contract-form';
import {EditDialogButton} from '@/components/refinedev/dialogs/edit-dialog-button';
import {Tabs} from '@/shadcn_components/ui/tabs';
import {BaseKey, UseCanProps} from '@refinedev/core';

export const ProjectContractEditDialogButton = ({
  id,
  onSuccess,
  canParams,
  // forceCan,
}: {
  id: BaseKey;
  onSuccess?: (data) => void;
  canParams?: UseCanProps['params'];
  // forceCan?: boolean;
}) => {
  return (
    <Tabs defaultValue="general_info">
      <EditDialogButton
        id={id}
        resource={'project_contracts'}
        canParams={canParams}
        title={
          <div className="flex flex-col gap-2">
            <span>Chỉnh sửa thông tin hợp đồng</span>
            <ProjectContractForm_TabsList />
          </div>
        }
        transformBeforeSave={ProjectContractForm.transformBeforeSave}
        formProps={{
          refineCoreProps: {
            onMutationSuccess: onSuccess,            
          },
        }}>
        <div className="flex flex-col gap-4">
          <ProjectContractForm_TabsContents />
        </div>
      </EditDialogButton>
    </Tabs>
  );
};
